module.exports = __webpack_public_path__ + "a2dda093265bd1f384c7c477fc9d9c20.jpg";